<template>
  <div style="width: 100%">
    <template v-if="fechamentoSemanal.length > 0">
      <div class="d-flex align-center mb-3">
        <v-icon small color="primary" class="mr-1">mdi-calendar-week</v-icon>
        <span class="caption font-weight-bold primary--text">
          {{ fechamentoSemanal.length }} semana(s) disponíveis neste período
        </span>
      </div>
      <div
        style="display: grid; grid-template-columns: repeat(auto-fill, minmax(155px, 1fr)); gap: 8px"
      >
        <div
          v-for="(item, index) in fechamentoSemanal"
          :key="index"
          class="rounded pa-3"
          style="border: 1px solid rgba(25,118,210,0.25); background: rgba(25,118,210,0.04)"
        >
          <p class="caption font-weight-bold primary--text ma-0 mb-2">
            Semana {{ index + 1 }}
          </p>
          <div class="d-flex align-center mb-1" style="gap: 4px">
            <v-icon x-small color="grey darken-1"
              >mdi-calendar-arrow-right</v-icon
            >
            <span class="caption grey--text">{{
              item.data_inicio | BrazilianStandardDate
            }}</span>
          </div>
          <div class="d-flex align-center" style="gap: 4px">
            <v-icon x-small color="grey darken-1"
              >mdi-calendar-arrow-left</v-icon
            >
            <span class="caption grey--text">{{
              item.data_final | BrazilianStandardDate
            }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <v-alert
        v-if="hasPermissionFechamento"
        color="warning"
        class="white--text mb-0"
      >
        <v-icon color="white" class="mr-1">mdi-alert</v-icon>
        Não há semanas de fechamento disponíveis para criar uma campanha! Clique
        <a
          href="/parametros/tipo-fechamento"
          target="_self"
          class="link-tipo-fechamento"
          >aqui</a
        >
        para cadastrar fechamentos.
      </v-alert>
      <v-alert v-else color="warning" class="white--text mb-0">
        <v-icon color="white" class="mr-1">mdi-alert</v-icon>
        Não há semanas de fechamento disponíveis. Entre em contato com a gestão
        comercial.
      </v-alert>
    </template>
  </div>
</template>

<script>
import dateMixin from "@/mixins/dateMixin.js";
import { mapGetters } from "vuex";
export default {
  name: "TableFechamentoSemanais",

  props: {
    fechamentoSemanal: {
      type: Array,
      default: () => []
    }
  },

  mixins: [dateMixin],

  data() {
    return {
      hasPermissionFechamento: true
    };
  },

  computed: {
    ...mapGetters({
      getUsers: "getUsers"
    })
  },

  methods: {
    verificaNivel() {
      if (this.getUsers?.nivel != "1" && this.getUsers?.nivel != "2") {
        this.hasPermissionFechamento = false;
      }
    }
  },

  mounted() {
    this.verificaNivel();
  }
};
</script>

<style>
.link-tipo-fechamento {
  color: purple !important;
  text-decoration: none !important;
  font-weight: bold !important;
}
</style>
